import { Box, Typography } from '@mui/material';
import { constants } from '../constants';
import React from 'react';
import AlertStateIcon from '../../public/AlertStateIcon.svg';
import authenticatedRoute from '@/views/AuthenticatedRoute';
function AccessUnavailable() {
    return /*#__PURE__*/ React.createElement(Box, {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
    }, /*#__PURE__*/ React.createElement(Box, {
        textAlign: 'center'
    }, /*#__PURE__*/ React.createElement("img", {
        src: AlertStateIcon,
        alt: '404',
        width: 120,
        height: 120,
        style: {
            marginBottom: 28
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: '#000000DE',
        mb: 1,
        fontWeight: 600
    }, constants.title_Access_unavailable), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: '#333333',
        sx: {
            marginBottom: 3.75
        }
    }, constants.desc_Access_unavailable)));
}
export default authenticatedRoute(AccessUnavailable);
